import gql from 'graphql-tag';

export const EVENT_BY_ID = gql`
  query GetEventById($eventId: ID) {
    event(id: $eventId) {
      id
      description
      name
      checkInTime
      checkOutTime
      startDate
      endDate
      protectedStartDate
      protectedEndDate
      protectedEvent
      hidden
      openDate
      closeDate
      createdAt
      phone
      stallQuestions {
        id
        question
        questionType
        answerOptions
        required
        minLength
        maxLength
        saved
      }
      stallProducts {
        id
        nightly
        startDate
        endDate
        booked
        name
        description
        price
        stalls {
          id
        }
        bookedStalls
        soldOut
        minNights
        stallFlip
        stats {
          id
          sold
          assigned
          totalPhysicalSpots
          flip
          maxDailyOccupancy
          dailyStats {
            date
            spotsOccupied
            spotsAssigned
          }
        }
      }
      rvQuestions {
        id
        question
        answerOptions
        questionType
        required
        listOrder
        minLength
        maxLength
        saved
      }
      rvProducts {
        id
        startDate
        endDate
        nightly
        price
        booked
        assignedSpots
        rvLot {
          id
          name
        }
        rvSpots {
          id
          name
        }
        minNights
        rvFlip
        stats {
          id
          sold
          assigned
          totalPhysicalSpots
          flip
          maxDailyOccupancy
          dailyStats {
            date
            spotsOccupied
            spotsAssigned
          }
        }
      }
      orders {
        id
      }
      addOnProducts {
        id
        price
        booked
        disabled
        addOn {
          id
          name
          unitName
        }
      }
      requiredAddOns {
        id
        eventId
        addOnProduct
        xRefTypeId
        ratio
        condition
        max
      }
      venueAgreement {
        id
        name
        description
        url
      }
      venueMap {
        id
        name
      }
      isGroupCodeRequired
      allowAddOnOnlyOrder
      eventLinks {
        id
        url
        label
        description
      }
    }
  }
`;
